import { createBaseQuery } from './createBaseQuery.mjs';
import { ReactQuery } from './utils.mjs';

function createQuery(options) {
  return createBaseQuery(options, ReactQuery.useQuery);
}

export { createQuery };
//# sourceMappingURL=createQuery.mjs.map
